const descTotal = badge => {
  switch (badge) {
    case 5:
      return 'more than >10000 tips';
    case 4:
      return 'in range 5001 - 10000 tips';
    case 3:
      return 'in range 2001 - 5000 tips';
    case 2:
      return 'in range 501 - 2000 tips';
    case 1:
      return 'in range 101 - 500 tips';
    default:
      return '';
  }
}

const descPercent = badge => {
  switch (badge) {
    case 5:
      return 'more than 65%';
    case 4:
      return 'between 60% and 65%';
    case 3:
      return 'between 55% and 60%';
    case 2:
      return 'between 50% and 55%';
    case 1:
      return 'between 45% and 50%';
    default:
      return '';
  }
}

export const badgeDesc = ([index, badge]) => {
  const desc = [
    'Total of created tips is ' + descTotal(badge),
    'The success rate for tips in general is ' + descPercent(badge),
    'The success rate for tickets is ' + descPercent(badge),
    'The success rate for the risky tips is ' + descPercent(badge),
    'The success rate for the regular tips is ' + descPercent(badge),
    'The success rate for the safe tips is ' + descPercent(badge),
  ]

  return desc[index]
}
